import styled from 'styled-components';

interface TitleProps {
    size?: 'small' | 'medium';
}

export const Container = styled.div`
    display: flex;
    flex-direction: column;
}
`;

export const TitleLine = styled.h1<TitleProps>`
    font-size: ${(props) => props.size === "small" ? "1.2em" : "1.5em"};
    margin-bottom: 0;
    color: rgb(82, 82, 113);
    font-weight: 300;
}
`;

export const SubTitleLine = styled.span`
    font-size: 0.90em;
    color: #767777;
}
`;
